import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'
import routes from '@/Router/routes.constants'

import { customIntegrations, getIntegrationPayload } from './helpers'

const useIntegration = ({ id, selectedIntegration, storeId, setToastInfo }) => {
  const [hasChanges, setHasChanges] = useState(false)
  const [integration, setIntegration] = useState()

  const { fetchData: createIntegration, loading: creating } = useFetch(configurationServices.createIntegration, {
    doInitialRequest: false,
  })

  const { fetchData: editIntegration, loading: editing } = useFetch(configurationServices.editIntegration, {
    doInitialRequest: false,
  })

  const navigate = useNavigate()
  const { t } = useTranslation()

  const setInitValues = useCallback(() => {
    setIntegration(selectedIntegration)
    setHasChanges(false)
  }, [selectedIntegration])

  useEffect(() => {
    if (selectedIntegration && !integration) {
      setInitValues()
    }
  }, [integration, selectedIntegration, setInitValues])

  const revertChanges = () => {
    setInitValues()
  }

  const onChangeIntegration = (field, value) => {
    setIntegration({
      ...integration,
      configuration: { ...integration.configuration, [field]: { ...integration.configuration[field], value } },
    })
    setHasChanges(true)
  }

  const onSave = async () => {
    const payload = getIntegrationPayload(integration)

    if (id === 'new') {
      try {
        const data = await createIntegration({ storeId, integration: payload })
        setToastInfo({ show: true, message: t('Cambios guardados'), type: 'success' })
        const customIntegration = customIntegrations[integration.type]

        if (customIntegration) {
          await customIntegration({ storeId, integrationId: data.id })
        } else {
          navigate(routes.configurationPage.integrations)
        }
      } catch (error) {
        setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
      }
    } else {
      try {
        const data = await editIntegration({ storeId, integration: payload })
        setToastInfo({ show: true, message: t('Cambios guardados'), type: 'success' })
        setHasChanges(false)
        const customIntegration = customIntegrations[integration.type]

        if (customIntegration) {
          await customIntegration({ storeId, integrationId: data.id })
        } else {
          navigate(routes.configurationPage.integrations)
        }
      } catch (error) {
        setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
      }
    }
  }

  return {
    integration,
    hasChanges,
    setHasChanges,
    revertChanges,
    onSave,
    onChangeIntegration,
    creating,
    editing,
  }
}

export default useIntegration
